// Smart logging utility for production safety
const isDevelopment = process.env.NODE_ENV === 'development';

class Logger {
  static log(...args) {
    if (isDevelopment) {
      console.log(...args);
    }
  }

  static error(...args) {
    // Always log errors, but sanitize in production
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, only log generic error messages
      console.error('An error occurred. Check network tab for details.');
    }
  }

  static warn(...args) {
    if (isDevelopment) {
      console.warn(...args);
    }
  }

  static debug(...args) {
    // Debug logs only in development
    if (isDevelopment) {
      console.log('🐛 DEBUG:', ...args);
    }
  }

  static info(...args) {
    // Info logs only in development
    if (isDevelopment) {
      console.info('ℹ️ INFO:', ...args);
    }
  }

  // Safe logging for production - only logs non-sensitive info
  static safeLog(message, data = null) {
    if (isDevelopment) {
      console.log(message, data);
    } else {
      // In production, only log the message without data
      console.log(message);
    }
  }
}

export default Logger; 